
































































































































export default {
	name: 'InterviewFilters',

	props: {
		clearingFilters: {
			default: false,
			required: false,
			type: Boolean,
		},
	},

	data() {
		return {
			loadingClear: false,
			loadingFilters: false,
			slideIn: false,
			filters: {
				interview_type: null,
				status: null,
				from_date: null,
				to_date: null,
			},
			interviewTypes: [
				{ value: 'video', text: 'Video' },
				{ value: 'phone', text: 'Phone' },
				{ value: 'in-person', text: 'In Person' },
			],
			interviewStatusTypes: [
				{ value: 'pending', text: 'Pending' },
				{ value: 'accepted', text: 'Accepted' },
				{ value: 'rejected', text: 'Rejected' },
			],
		}
	},

	computed: {
		currentFilters() {
			return this.$store.getters['interviews/getFilters'];
		},
	},

	watch: {
		slideIn(newValue) {
			if (!newValue) {
				this.hideInterviewFilters();
			}
		},

		currentFilters() {
			let filters = JSON.parse(JSON.stringify(this.currentFilters));

			if (typeof filters.interview_type === 'string') {
				filters.interview_type = this.interviewTypes.find(
					(type) => type.value === filters.interview_type,
				);
			}

			if (typeof filters.status === 'string') {
				filters.status = this.interviewStatusTypes.find(
					(type) => type.value === filters.status,
				);
			}

			this.filters = filters;
		},

		clearingFilters(value) {
			//
		},
	},

	created() {
		this.slide();

		if (this.currentFilters) {
			this.filters = JSON.parse(JSON.stringify(this.currentFilters));
		}
	},

	methods: {
		slide() {
			setTimeout(() => {
				this.slideIn = !this.slideIn;
			}, 200);
		},

		hideInterviewFilters() {
			setTimeout(() => {
				this.$store.dispatch('interviews/setShowFilters', false);
			}, 300);
		},

		applyFilters() {
			this.loadingFilters = true;
			this.$store.dispatch('interviews/setCursor', null);
			this.$store.dispatch(
				'interviews/setFilters',
				JSON.parse(JSON.stringify(this.filters)),
			);

			this.$store
				.dispatch('interviews/fetchCandidateInterviews')
				.then(() => {
					this.loadingFilters = false;
					this.slide();
				})
				.catch((err) => {
					this.loadingFilters = false;
				});
		},

		clearFilters() {
			this.filters = {
				interview_type: null,
				status: null,
				from_date: null,
				to_date: null,
			};

			this.loadingClear = true;
			this.$store.dispatch('interviews/setCursor', null);
			this.$store.dispatch(
				'interviews/setFilters',
				JSON.parse(JSON.stringify(this.filters)),
			);

			this.$store
				.dispatch('interviews/fetchCandidateInterviews')
				.then(() => {
					this.loadingClear = false;
					this.slide();
				})
				.catch((err) => {
					this.loadingFilters = false;
				});
		},
	},
};
